<template>
    <div>
        <h2 class="title typographies-heading-h2">{{ $l10n.__('Paramètres de l’import') }}</h2>
        <p class="subtitle typographies-paragraph-medium-regular">
            {{
                $l10n.__(
                    'Cette section vous permet de déterminer les actions que nous allons effectuer lors du traitement de l’import.',
                )
            }}
        </p>
        <div class="option-type-container">
            <div v-for="(optionType, key) in parameters" :key="key">
                <h3 class="typographies-heading-h3 option-type-title">{{ optionType.title }}</h3>
                <div class="parameter-container">
                    <div
                        v-for="(parameter, parameterKey) in optionType.options"
                        :key="parameterKey"
                        class="parameter-item"
                    >
                        <div class="parameter-title">
                            <span class="typographies-paragraph-medium-semibold">
                                {{ parameter.title }}
                            </span>
                            <CompassTooltip
                                content-class="tooltip-import-options"
                                placement="bottom-start"
                            >
                                <template slot="content">
                                    <div v-for="choice in parameter.values" :key="choice.value">
                                        <h4 class="typographies-heading-h4">{{ choice.label }}</h4>
                                        <p class="typographies-paragraph-small-semibold">
                                            {{ choice.description }}
                                        </p>
                                    </div>
                                </template>
                                <CompassIcon icon="info-circle-fill" size="small" />
                            </CompassTooltip>
                        </div>
                        <CompassSelect
                            v-model="getOptionsSelectedImport[parameterKey]"
                            menu-class="menu-import-dialog"
                        >
                            <CompassDropdownSelectOption
                                v-for="option in parameter.values"
                                :key="option.value"
                                v-bind="option"
                            />
                        </CompassSelect>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const importsStore = createNamespacedHelpers('importsStore');
export default {
    data() {
        return {
            parameters: null,
        };
    },
    computed: {
        ...importsStore.mapGetters([
            'getOptionsImport',
            'getOptionsSelectedImport',
            'getCurrentSubStep',
        ]),
    },
    created() {
        this.parameters = this.getOptionsImport.parameters;
    },
    beforeMount() {
        //We set isValid at creation of component because for know it cannot be false
        this.getCurrentSubStep.isValid = true;
    },
};
</script>

<style lang="scss" scoped>
h3 {
    margin: 0;
}
.option-type {
    &-container {
        display: flex;
        flex-direction: column;
        gap: var(--spacing-4);
        padding-bottom: var(--spacing-6);

        .parameter-title::v-deep {
            .compass-icon {
                color: var(--colors-common-icon-neutral);
            }
        }
    }

    &-title {
        margin-bottom: var(--spacing-1);
    }
}
</style>

<style lang="scss">
#compass-tooltip-container {
    .tooltip-import-options-identifiers {
        z-index: 1001;

        .compass-tooltip__item__content {
            display: flex;
            flex-direction: column;
            gap: var(--spacing-2);
        }
    }
}
</style>
